import React, { ReactElement, useState } from 'react';
import { Nav, TabContainer, TabContent, TabPane } from 'react-bootstrap';
import diamondIcon from '../../../../assets/png/diamond.png';
import { useGetGiftCategoriesQuery } from '../../../../services/api/apiProvider';
import { ResponseGiftCategory } from '../../../../services/api/models/response/responseGift';
import { AuthState, useAuth } from '../../../auth/AuthProvider';
import { LiveProps } from '../../LiveContainer';
import { EventGiftTab } from './EventGiftTab';
import { GiftTab } from './GiftTab';
import './LiveGiftMenu.scss';
import { FreeGiftTab } from './FreeGiftTab';
import { ClassicGiftTab } from './ClassicGiftTab';
import { CHARGE_URL } from '../../../../loadEnv';

export const LiveGiftMenu = (props: LiveProps): ReactElement => {
  const { data: giftCategories } = useGetGiftCategoriesQuery();
  const { userCoin } = useAuth() as AuthState;
  const [tabKey, setTabKey] = useState<string | null>(null);

  const renderTab = (category: ResponseGiftCategory): ReactElement => {
    if (category.name === 'イベント') {
      if (props.liveState.liveData?.events) {
        return (
          <EventGiftTab
            giftCategory={category}
            events={props.liveState.liveData?.events}
          />
        );
      } else {
        return <></>;
      }
    } else if (category.name === 'ボーナス') {
      return <FreeGiftTab />;
    } else if (category.name === '定番') {
      return <ClassicGiftTab giftCategory={category} tabKey={tabKey} />;
    } else {
      return <GiftTab giftCategory={category} />;
    }
  };

  return (
    <div className="gift-menu box-shadow-2">
      <div className="gift-menu__tabs">
        {giftCategories && (
          <TabContainer
            mountOnEnter
            defaultActiveKey={giftCategories[0]?.id}
            onSelect={(k) => setTabKey(k)}
          >
            {/* Tab Header*/}
            <Nav fill variant="tabs">
              {giftCategories.map((category) => {
                return (
                  <Nav.Item key={category.id}>
                    {category.displayName ? (
                      <Nav.Link eventKey={category.id}>
                        {category.displayName}
                      </Nav.Link>
                    ) : (
                      <Nav.Link eventKey={category.id}>
                        {category.name}
                      </Nav.Link>
                    )}
                  </Nav.Item>
                );
              })}
            </Nav>

            {/* Tab Content*/}
            <TabContent>
              {giftCategories.map((category) => (
                <TabPane key={category.id} eventKey={category.id}>
                  {renderTab(category)}
                </TabPane>
              ))}
            </TabContent>
          </TabContainer>
        )}
      </div>

      <div className="gift-menu__wallet">
        <img className="diamond-icon" src={diamondIcon} />
        <span className="diamond-amount">{userCoin.toLocaleString()}</span>
        <span
          onClick={() => {
            window.open(CHARGE_URL);
          }}
        >
          チャージ
        </span>
      </div>
    </div>
  );
};
